import {Skin} from "@pixi-spine/runtime-3.8";
import {MiniSignal, selectRandom, spine} from "p3";
import definitions from "../../../definitions";
import BossFightScene from "../../../scenes/BossFightScene";
import Entity from "../../Entity";

export default class BossBert extends Entity {
    constructor() {
        super();

        this._idleAnimations = [
            "idle_00",
            "idle_01",
            "idle_02"
        ];

        this._defaultTween = null;

        this._isIdleAnimation = false;
        this._isWalkAnimation = false;
        
        this.signals.healIvandoe = new MiniSignal();
    }

    init() {
        super.init();

        this._damageEffectFilter = new P3.filters.AdditiveFilter(0, 3);

        this.addViewWithSpine(spine("char_bert"));

        this._view.y = -100;
        this._view.stateData.defaultMix = 0.1;
        this._view.scale.set(0.32 * this.facingDirection, 0.32);

        this.playIdleAnimation();

        this.signals.healIvandoe.add(this._startHealIvandoe, this);
    }

    destroy() {
        super.destroy();
    }

    onViewAdded() {
        super.onViewAdded();
    }

    update() {
        super.update();
        this._view && this._view.update(window.dt);
    }

    _startHealIvandoe() {
        this.playAnimation("fly_r_heal_00", true, true);
    }

    playIdleAnimation(add=true) {
        this.playAnimation(selectRandom(this._idleAnimations), true, add);
    }

    onAnimationComplete(name, entry) {
        if (this._idleAnimations.indexOf(name) >= 0) {
            this._isIdleAnimation = false;
        }
    }
}